import { SPONSORS_ACTIONS } from "./SPONSORS_ACTIONS"


export function sponsorsReducer(state, action) {
  switch (action.type) {
    case SPONSORS_ACTIONS.SET_SPONSORS:
      return {
        ...state,
        sponsors: action.payload.sponsors,
        pagination: action.payload.pagination,
      }
    case SPONSORS_ACTIONS.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading }
    default:
      return state
  }
}